import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Employeur } from '../model/employeur';

@Injectable({
    providedIn: 'root'
  })
  export class EmployeurService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllEmployeurs(){
      return this._restClientService.load<Employeur[]>("employeur/employeurs");
    }

    getEmployeurById(employeurId){
      return this._restClientService.load<Employeur>('employeur/employeur-by-id/'+employeurId);
    }

    update(updateEmployeur : Employeur) {
      return  this._restClientService.put<Employeur>(`employeur/update-employeur`, updateEmployeur);
    }
   
    add(createEmployeur : Employeur) {
      return  this._restClientService.save<Employeur>('employeur/add-employeur', createEmployeur);
    }
   
}      

    